import { Component } from '@angular/core';

/**
 * Animación de carga "generación de rutas" — SVG + CSS autocontenido (sin
 * dependencias). Una ruta que se traza sola, un marcador que la recorre y
 * waypoints que laten, en la paleta índigo del tema.
 */
@Component({
  selector: 'app-route-loading-animation',
  standalone: true,
  template: `
    <svg viewBox="0 0 200 170" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-full w-full">
      <!-- halo suave -->
      <circle cx="100" cy="90" r="74" fill="#EEF2FF" class="halo" />

      <!-- ruta base (tenue) -->
      <path #route d="M28,140 C60,120 70,80 100,82 S150,70 172,38"
        stroke="#C7D2FE" stroke-width="7" stroke-linecap="round" />

      <!-- ruta que se traza -->
      <path d="M28,140 C60,120 70,80 100,82 S150,70 172,38"
        stroke="#6366F1" stroke-width="7" stroke-linecap="round" class="trace" />

      <!-- marcador que recorre la ruta -->
      <circle r="6.5" fill="#4338CA">
        <animateMotion dur="2.4s" repeatCount="indefinite" keyPoints="0;1" keyTimes="0;1"
          calcMode="spline" keySplines="0.45 0 0.2 1"
          path="M28,140 C60,120 70,80 100,82 S150,70 172,38" />
      </circle>

      <!-- waypoints que laten -->
      <circle cx="28" cy="140" r="8" fill="#6366F1" class="wp wp1" />
      <circle cx="100" cy="82" r="7" fill="#14B8A6" class="wp wp2" />
      <circle cx="172" cy="38" r="9" fill="#6366F1" class="wp wp3" />
    </svg>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      .halo {
        transform-origin: 100px 90px;
        animation: rla-halo 2.4s ease-in-out infinite;
      }
      .trace {
        stroke-dasharray: 240;
        stroke-dashoffset: 240;
        animation: rla-draw 2.4s ease-in-out infinite;
      }
      .wp {
        transform-box: fill-box;
        transform-origin: center;
        animation: rla-pulse 1.6s ease-in-out infinite;
      }
      .wp1 {
        animation-delay: 0s;
      }
      .wp2 {
        animation-delay: 0.5s;
      }
      .wp3 {
        animation-delay: 1s;
      }
      @keyframes rla-draw {
        0% {
          stroke-dashoffset: 240;
        }
        55% {
          stroke-dashoffset: 0;
        }
        100% {
          stroke-dashoffset: -240;
        }
      }
      @keyframes rla-pulse {
        0%,
        100% {
          transform: scale(0.7);
          opacity: 0.6;
        }
        50% {
          transform: scale(1.15);
          opacity: 1;
        }
      }
      @keyframes rla-halo {
        0%,
        100% {
          transform: scale(0.92);
          opacity: 0.6;
        }
        50% {
          transform: scale(1.05);
          opacity: 1;
        }
      }
    `,
  ],
})
export class RouteLoadingAnimationComponent {}
